import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { AzavistaApiService, IUserMessageLogItem, RecipientType } from '@azavista/servicelib';
import { IField, IPagingOptions, ITableSettingsChangedData } from '@azavista/components/shared';
import { SharedService } from 'src/app/shared/shared.service';
import { RecipientMessagesService } from './recipient-messages.service';
import { AzavistaTableComponent } from '@azavista/components/table';

@Component({
    selector: 'azavista3-recipient-messages',
    templateUrl: 'recipient-messages.component.html',
    standalone: false
})
export class RecipientMessagesComponent implements OnInit {
    @Input() recipientType: RecipientType;
    @Input() recipientId: number | string;

    columns: IField[];
    displayedColumns: string[];
    pagingOptions: IPagingOptions;
    data: IUserMessageLogItem[];
    loaded = false;

    private lastTableSettingsChangedData: ITableSettingsChangedData;

    @ViewChild(AzavistaTableComponent) table?: AzavistaTableComponent;

    constructor(private apiSvc: AzavistaApiService, private sharedSvc: SharedService, private recipientMessagesSvc: RecipientMessagesService) {
    }

    async ngOnInit(): Promise<void> {
        this.columns = this.recipientMessagesSvc.getColumns();
        this.displayedColumns = this.recipientMessagesSvc.getDisplayedColumns(this.columns);
        this.pagingOptions = this.sharedSvc.createDefaultPagingOptionsForLongLists();
        this.lastTableSettingsChangedData = this.sharedSvc.createDefaultTableSettingsChangedData();
        this.lastTableSettingsChangedData.sorting = { column: this.recipientMessagesSvc.getCreatedAtField(this.columns), direction: 'desc' };
        this.data = [];
        await this.searchMessages(this.lastTableSettingsChangedData);
        this.loaded = true;
    }

    async searchMessages(data: ITableSettingsChangedData): Promise<void> {
        this.lastTableSettingsChangedData = data;
        const req = this.sharedSvc.createAdvancedSearchRequest(data);
        const res = await this.apiSvc.searchRecipientTypeMessages(this.recipientType, this.recipientId, req);
        this.pagingOptions = this.sharedSvc.createPagingOptionsFromPagedResponse(res);
        await this.recipientMessagesSvc.setIntegrationNames(res.messages);
        this.data = res.messages;
    }
}
